import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", asLink = true, variant }) => {
  const Inner = variant === "aiv" ? (
    <span className={`flex items-center ${className}`} data-testid="brand-logo">
      <img
        src="/brand/aiv-logo.png?v=1"
        alt="Apex Infinity Ventures logo"
        className="h-[32px] md:h-[40px] w-auto object-contain"
        data-testid="brand-logo-mark"
      />
    </span>
  ) : (
    <span className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src="/brand/apex-infinity-mark.png"
        alt="Apex Infinity Ventures logo"
        className="w-9 h-9 object-contain"
        data-testid="brand-logo-mark"
      />
      <span className="leading-none">
        <span className="font-display text-xl text-white tracking-tight block">Apex Infinity</span>
        <span className="font-mono-apex text-[9px] uppercase tracking-[0.3em] text-zinc-500 mt-0.5 block">
          ventures
        </span>
      </span>
    </span>
  );

  if (!asLink) return Inner;
  return (
    <Link to="/" className="group">
      {Inner}
    </Link>
  );
};

export default Logo;
